import { createReducer } from 'redux-act';
import actions from '../actions/departmentAction';

const initialState = {
  getSidebarPending: false,
  getSidebarRes: null,
  getSidebarError: null,

};

/* Get Sidebar  Reducers */
const handleGetSidebarRequest = state1 => {
  return {
    ...state1,
    ...{
      getSidebarPending: true,
      getSidebarRes: null,
      getSidebarError: null,
    },
  };
};
const handleGetSidebarSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getSidebarPending: false,
      getSidebarRes: payload,
      getSidebarError: null,
    },
  };
};
const handleGetSidebarError = (state1, payload) => ({
  ...state1,
  ...{
    getSidebarPending: false,
    getSidebarRes: null,
    getSidebarError: payload,
  },
});




export default createReducer(
  {
   
    [actions.getSidebarRequest]: handleGetSidebarRequest,
    [actions.getSidebarSuccess]: handleGetSidebarSuccess,
    [actions.getSidebarError]: handleGetSidebarError,
  },
  initialState,
);